export const logoutSession = () => {
    return {
        type: "LOGOUT",
    };
};

export const loginSession = (data) => {
    console.log("set login: " + JSON.stringify(data))
    return {
        type: "LOGIN",
        payload: data
    };
};